export const OPEN_ORDER_DETAILS = 'open_order_details';
export const CLOSE_ORDER_DETAILS = 'close_order_details';
export const SEND_TO_SUPPLIER = 'send_to_supplier';
export const CHANGE_SHOP_STATE = 'change_shop_state';
export const UPDATE_SUGGESTED_ADDRESSES = 'update_suggested_addresses';
